import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  text: 'Nunca pensé que cocinar vegano podía ser tan fácil y tan rico. Las empanadas de pino vegano son un hit en mi casa, hasta mi marido las pide.',
  name: 'Valentina G.',
  city: 'Buenos Aires'
}, {
  text: 'Compré el pack PRO y el Master de Proteínas me cambió la vida. Ahora hago seitán casero y mis hijos no extrañan la carne para nada.',
  name: 'Romina M.',
  city: 'Córdoba'
}, {
  text: 'Los bonos valen oro. El Nutri Mapa me ayudó a entender por fin qué estaba comiendo y cómo equilibrar mis platos.',
  name: 'Luciana P.',
  city: 'Rosario'
}, {
  text: "Soy vegana hace 2 años y este pack me sacó del loop de 'siempre lo mismo'. Las recetas del Tomo 6 son impresionantes.",
  name: 'Jimena R.',
  city: 'Mendoza'
}, {
  text: 'Las fotos de las recetas son hermosas y los pasos son clarísimos. Lo recomiendo a todas mis amigas.',
  name: 'Camila S.',
  city: 'La Plata'
}, {
  text: 'Compré el pack base y a la semana compré el PRO. El chorizo vegano de seitán es increíble. Vale cada peso.',
  name: 'Florencia T.',
  city: 'Santa Fe'
}];
export function TestimonialsSection() {
  return <section className="bg-[#18181b] py-24 px-4" data-id="element-192">
      <div className="max-w-6xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-195">
            Lo que dicen quienes ya cocinan con Cocina Veggie
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#0a0a0a] border border-zinc-800 rounded-xl p-8 flex flex-col" data-id="element-197">
              <div className="text-yellow-500 mb-4 tracking-widest text-lg" data-id="element-198">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-zinc-300 italic mb-6 flex-grow" data-id="element-199">"{t.text}"</p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-200">
                <p className="text-white font-bold" data-id="element-201">{t.name}</p>
                <p className="text-zinc-500 text-sm" data-id="element-202">{t.city}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}